require('./blocks/about.css');
require('./blocks/benefits/benefits');
require('./blocks/benefit.less');
require('./blocks/reviews/reviews');
require('./blocks/review.less');
require('./blocks/map-block.less');
require('./blocks/brands-slider/brands-slider');
require('./blocks/about-certificates/about-certificates');
require('./blocks/promos/promos');
require('./blocks/dealer-banner/dealer-banner-about.less');



// WEBPACK FOOTER //
// ./about.js